module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "sidebar-menu"
  }, [_c('li', {
    staticClass: "pageLink",
    attrs: {
      "tag": "li"
    },
    on: {
      "click": _vm.reload
    }
  }, [_vm._m(0)]), _vm._v(" "), (_vm.user) ? _c('li', {
    staticClass: "header"
  }, [_vm._v("OPERACIONES")]) : _vm._e(), _vm._v(" "), _c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "tag": "li",
      "to": "/"
    }
  }, [_c('a', [_c('i', {
    staticClass: "fa fa-home"
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("Inicio")])])]), _vm._v(" "), (false) ? _c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "tag": "li",
      "to": "/individual"
    }
  }, [_c('a', [_c('i', {
    staticClass: "fa fa-search"
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("Consulta individual")])])]) : _vm._e(), _vm._v(" "), _c('li', {
    staticClass: "header"
  }, [_vm._v("CUENTA")]), _vm._v(" "), (!_vm.user) ? _c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "tag": "li",
      "to": "/login"
    }
  }, [_c('a', [_c('i', {
    staticClass: "fas fa-sign-in-alt text-yellow"
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("Ingresar al Portal")])])]) : _vm._e(), _vm._v(" "), (_vm.user) ? _c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "tag": "li",
      "to": "/changePsw"
    }
  }, [_c('a', [_c('i', {
    staticClass: "fas fa-key"
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("Cambiar clave")])])]) : _vm._e(), _vm._v(" "), (_vm.user) ? _c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "tag": "li",
      "to": "/selfdata"
    }
  }, [_c('a', [_c('i', {
    staticClass: "fa fa-user"
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("Mis datos")])])]) : _vm._e(), _vm._v(" "), (_vm.user && false) ? _c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "tag": "li",
      "to": "/comments"
    }
  }, [_c('a', [_c('i', {
    staticClass: "fa fa-refresh"
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("Actualice sus datos")])])]) : _vm._e(), _vm._v(" "), (_vm.user) ? _c('li', {
    staticClass: "pageLink",
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": _vm.logout
    }
  }, [_vm._m(1)]) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', [_c('i', {
    staticClass: "fa fa-repeat"
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("Actualizar datos")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', [_c('i', {
    staticClass: "fa fa-sign-out-alt text-red"
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("Cerrar Sesión")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d704b668"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/SidebarMenu.vue
// module id = 656
// module chunks = 1